export const hideComponentActions = [
  {
    name: 'system_hide_component',
    label: 'Hide Component',
    args: [
      {
        name: 'source',
        label: 'Source',
        type: 'dropdown',
        optionsType: 'sourceApi',
        options: [],
        value: 'PAGE',
      },
      {
        name: 'hideComponentPage',
        label: 'Page',
        type: 'dropdown',
        optionsType: 'hideComponentPageApi',
        options: [],
        value: '',
      },
      {
        name: 'hideComponents',
        label: 'Hide Component',
        type: 'dropdown',
        optionsType: 'hidePageComponents',
        options: [],
        value: '',
      },
    ],
  },
];
